import React from 'react';
import { EmptyContentWrapper, Image, Message } from './EmptyContent.styles'
import FileImage from './FileSearch.svg';  // Dummy image

const EmptyContent = () => {
  return (
    <EmptyContentWrapper>
      <Image src={FileImage} alt="Empty Content" />
      <Message>
        There's nothing to see here yet.
        <br />
        Check back later for updates!
      </Message>
    </EmptyContentWrapper>
  );
};

export default EmptyContent;
